let ctx = null;

const getCtx = () => {
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  return ctx;
};

// Browsers only allow audio after a user gesture; unlock on first interaction.
export const unlockChime = () => {
  const c = getCtx();
  if (c && c.state === "suspended") c.resume().catch((e) => console.error("Audio unlock failed:", e));
};

export const playChime = () => {
  const c = getCtx();
  if (!c || c.state !== "running") return;
  const now = c.currentTime;
  [880, 1318.5].forEach((freq, i) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    const t = now + i * 0.16;
    osc.type = "sine";
    osc.frequency.value = freq;
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.3, t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
    osc.connect(gain).connect(c.destination);
    osc.start(t);
    osc.stop(t + 0.5);
  });
};
